import { ChevronsUpDown, LucideArrowLeftRight } from "lucide-react";
import { Link } from "react-router";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
	useSidebar,
} from "@/components/ui/sidebar";
import { m } from "@/paraglide/messages";
import { useOrganization } from "./useOrganization";

export function OrganizationNav() {
	const { isMobile } = useSidebar();
	return (
		<SidebarMenu>
			<SidebarMenuItem>
				<DropdownMenu>
					<DropdownMenuTrigger
						render={
							<SidebarMenuButton
								size="lg"
								className="data-[popup-open]:bg-sidebar-accent data-[popup-open]:text-sidebar-accent-foreground"
							>
								<OrganizationInfo />
								<ChevronsUpDown className="ml-auto size-4" />
							</SidebarMenuButton>
						}
					/>
					<DropdownMenuContent
						className="w-(--anchor-width) min-w-56 rounded-lg"
						side={isMobile ? "bottom" : "right"}
						align="end"
						sideOffset={4}
					>
						<DropdownMenuGroup>
							<DropdownMenuLabel className="p-0 font-normal">
								<div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
									<OrganizationInfo />
								</div>
							</DropdownMenuLabel>
						</DropdownMenuGroup>
						<DropdownMenuSeparator />

						<DropdownMenuGroup>
							<DropdownMenuItem
								render={
									<Link to="/">
										<LucideArrowLeftRight />
										{m.safe_wise_marten_yell()}
									</Link>
								}
							/>
						</DropdownMenuGroup>
					</DropdownMenuContent>
				</DropdownMenu>
			</SidebarMenuItem>
		</SidebarMenu>
	);
}

function OrganizationInfo() {
	const { organization } = useOrganization();

	return (
		<>
			<div className="text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-lg">
				<Avatar className="h-8 w-8 rounded-round">
					<AvatarImage
						src={organization.logoUrl ?? undefined}
						alt={organization.name}
					/>
					<AvatarFallback className="rounded-full">
						{organization.name.charAt(0).toUpperCase()}
					</AvatarFallback>
				</Avatar>
			</div>
			<div className="grid flex-1 text-left text-sm leading-tight">
				<span className="truncate font-medium">{organization.name}</span>
			</div>
		</>
	);
}
